export const COLORS = {
    light_blue: "#60B6D7",
    light_grey: "#F7F7F7",
    light_grey_darker: "#EEEEEE",
    light_grey_darker_hover: "#e3e3e3",
    text_green: "#9DBB13",
    text_grey: "#979797",
    darker_green: "#98BD30",
    green: "#B7E338",
    text_dark_green: "#5D731D",
    text_dark_blue: "#1378AB",

    orange: "#F68005",
    dark_orange: "#804303",
    orange_hover: "#d46f04",

    //Level colors
    level_one: "#F48954",
    level_one_text: "#793F22",

    level_two: "#60B6D7",
    level_two_text: "#0C4D6F",

    level_three: "#D76062",
    level_three_text: "#662D2E",

    level_four: "#B7E338",
    level_four_text: "#5D731D",

    level_five: "#A161CE",
    level_five_text: "#501D73",

    level_six: "#FFE500",
    level_six_text: "#958600"
}